/* import __COLOCATED_TEMPLATE__ from './modal.hbs'; */
import Component from '@ember/component';
import { assert } from '@ember/debug';
import { inject as service } from '@ember/service';
const REPAINT_HACK_SELECTOR = 'body';
const DESTINATION_ELEMENT_CLASS_NAME = 'prism-modal-destination-element';
function getOrCreateDestinationElement() {
  let element = document.querySelector(`.${DESTINATION_ELEMENT_CLASS_NAME}`);
  if (element) {
    return element;
  } else {
    element = document.createElement('div');
    element.classList.add(DESTINATION_ELEMENT_CLASS_NAME);
    document.body.appendChild(element);
  }
  return element;
}
export default Component.extend({
  tagName: '',
  userAgent: service(),
  /**
   * Element to render the modal into. If not provided then
   * the modal will render directly into the document body
   *
   * @argument destinationElement
   * @type {Element}
   */
  destinationElement: null,
  /**
   * True if the modal uses the bottom sheet style on small screens.
   *
   * @argument useBottomSheet
   * @type {Boolean}
   */
  useBottomSheet: false,
  /**
   * action to handle when the modal screen is clicked and wants to close.
   *
   * @argument onClose
   * @type {Action}
   */
  onClose: () => {},
  init(...args) {
    this._super(...args);
    if (!this.destinationElement) {
      this.destinationElement = getOrCreateDestinationElement();
    }
    assert('Must provide a close action', this.onClose);
  },
  didInsertElement() {
    document.querySelector('.prism-modal').focus();
    this._forceRepaint();
  },
  willDestroy() {
    this._forceRepaint();
  },
  // This selector can be overridden by an app by re-exporting this component
  // in it's namespace.
  _repaintHackSelector: REPAINT_HACK_SELECTOR,
  // On iOS Safari we have observed rendering issues when opening and closing
  // modals. The DOM will be in the correct state but the rendered page will be
  // broken. Forcing the browser to repaint the page appears to fix the issue.
  //
  // https://jira.sqcorp.co/browse/CBF-981
  // https://stackoverflow.com/questions/8840580/force-dom-redraw-refresh-on-chrome-mac
  _forceRepaint() {
    if (this.userAgent.os.isIOS) {
      const hackElement = document.querySelector(this._repaintHackSelector);
      hackElement.style.display = 'none';
      hackElement.style.display = '';
    }
  },
  actions: {
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.onClose();
      }
    },
    handleMousedown(event) {
      this.mousedownEvent = event;
    },
    handleMouseup(event) {
      // If the target of the click is the modal screen (indiciated by a data
      // attribute) then we want to close the modal.
      if (this.mousedownEvent.target.dataset.modalScreen &&
      // started on the modal screen
      event.target.dataset.modalScreen &&
      // finished on the modal screen
      event.button === 0 &&
      // left click
      this.onClose) {
        this.onClose();
      }
      delete this.mousedownEvent;
    }
  }
});